export default __webpack_public_path__ + "static/media/landingInfographic4.3b6b8b10.png";